import { Pipe, PipeTransform } from '@angular/core';

import { REFERENCES_WITH_DISABLED_BOM_PDF } from '../../enclosure/models/devices.constants';
import { IBOMItem } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'bomPdfIconEnabled',
    standalone: false
})
export class BomPdfIconEnabledPipe implements PipeTransform {

  transform(article: Partial<IBOMItem>): boolean {
    if (!article || article.isCustomDevice === true) {
      return false;
    }

    return !REFERENCES_WITH_DISABLED_BOM_PDF.includes(article.ref);
  }

}
